const fulfillmentTypes = Object.freeze({
  DELIVERY: 'delivery',
  PICKUP: 'pickup',
  DROPOFF: 'dropoff'
});

// this shouldn't be necessary. In order to reduce this complication we need to normalize
// existing data first
export const FULFILLMENT_TYPES_MAP = {
  delivery: 'Bezorgen',
  pickup: 'Ophalen',
  dropoff: 'Dropoff'
};

export default fulfillmentTypes;
